import { RESET_STATE } from 'store/global/actions';
import { LOAN_APPLICATION_BORROWERS_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = null;

const loanApplicationBorrowersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_APPLICATION_BORROWERS_ACTION_TYPE.GET_BORROWERS_TABLE_DATA: {
      return payload || initialState;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanApplicationBorrowersReducer;
